import { ROUTE_PATHS } from '@constants/routes';
import { Box, Stack } from '@mui/material';
import { alpha, type Theme } from '@mui/material/styles';
import { useAppSelector } from '@store/hooks';
import AppTheme from '@theme/theme';
import React, { useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import CertificateBanner from './CertificateBanner';
import AppNavbar from './Navbar/AppNavbar';
import SideBar from './Sidebar/Sidebar';

const MainLayout: React.FC = () => {
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  const [isDrawerOpen, setDrawerOpen] = useState(false);

  if (!isAuthenticated) return <Navigate to={ROUTE_PATHS.LOGIN} replace />;

  return (
    <AppTheme disableCustomInputs={true}>
      <Box sx={mainContainerStyles}>
        <SideBar />
        <AppNavbar toggleDrawer={() => setDrawerOpen(!isDrawerOpen)} open={isDrawerOpen} />
        <Box component='main' sx={(theme) => mainContentStyles(theme)}>
          <Stack spacing={2} sx={contentStackStyles}>
            <CertificateBanner />
            <Outlet />
          </Stack>
        </Box>
      </Box>
    </AppTheme>
  );
};

const mainContainerStyles = {
  display: 'flex',
  width: '100%',
  height: '100vh',
};

const mainContentStyles = (theme: Theme) => ({
  flexGrow: 1,
  backgroundColor: theme.cssVariables
    ? `rgba(${theme.palette.background.default} / 1)`
    : alpha(theme.palette.background.default, 1),
  overflow: 'auto',
  alignItems: 'start',
  justifyContent: 'center',
  display: 'flex',
});

const contentStackStyles = {
  alignItems: 'start',
  justifyContent: 'start',
  mx: 3,
  pb: 5,
  mt: { xs: 8, md: 8, lg: 0 },
  maxWidth: { xs: '100%', md: '900px', lg: '1100px', xl: '1500px' },
  // No floor on a narrow screen: 90% of the main area plus the 24 px margin on each side is wider
  // than the main area below 480 px, and every page scrolled sideways by 5 px at 390.
  minWidth: { xs: 0, md: '700px', lg: '800px', xl: '1000px' },
  width: '100%'
};

export default MainLayout;
